import defaults from '@mailobj-browser/front/js/selectors/defaults.js'
import object from '@mailobj-browser/front/js/utils/object.js'

import custom from './custom.js'
import send from './send.js'
import sendMultiple from './sendmultiple.js'

const intents = new Object()

const missing = name => {
  throw new ReferenceError(`Intent ${name} not managed`)
}

const traps = object(null, {
  get: (refs, intentName) => {
    if (refs[intentName]) {
      return refs[intentName]
    } else {
      missing(intentName)
    }
  }
})

export const add = (intentDef) => {
  const { action, task } = intentDef
  if (!Object.hasOwn(intents, action)) {
    intents[action] = task
  }
}

add(custom('ADBOOK', 'adbook/addresses'))
add(custom('CALENDAR', 'calendar/view'))
add(send)
add(sendMultiple)

//const proxy = new Proxy(intents, traps)

export const execute = async (intent) => {
  const { action } = intent
  //const callable = proxy[action]
  //return await callable(intent)
  if (Object.hasOwn(intents, action)) {
    return await intents[action](intent)
  }
  missing(action)
}

//export default proxy
export default intents
